import {
  ErrorCodeEnum,
  ErrorResponseWithTemplatesAllOfTemplates,
} from '@ulysses-inc/harami_api_client'

// エラーレスポンスに含まれるひな形情報（OpenAPI 生成型の re-export）
export type ErrorTemplateRef = ErrorResponseWithTemplatesAllOfTemplates

// 400系/500系エラーのときにharami_api_serverが返してくるレスポンスの型
export interface HTTPError {
  status: number
  code: ErrorCodeEnum
  errors: Array<string>
}

// ひな形使用中エラー（CannotDeleteMasterFieldDefUsedInTemplateError）専用の拡張型
export interface HTTPErrorWithTemplates extends HTTPError {
  templates?: Array<ErrorTemplateRef>
}

/**
 * 与えられたerrorがHTTPErrorであるかどうかを判別する
 */
const isHTTPError = (error: unknown): error is HTTPError => {
  if (error === undefined || error === null || typeof error !== 'object') {
    return false
  }
  return 'code' in error
}

/**
 * 与えられたerrorが指定のcodeを持っているかを判別する
 *
 * HTTPErrorではないerrorが渡された場合はfalseを返却する
 */
const errorIs = (error: unknown, code: ErrorCodeEnum): boolean => {
  if (!isHTTPError(error)) {
    return false
  }
  return error.code === code
}

/**
 * Open API Clientがthrowするエラーをunwrapして再びthrowする
 *
 * TODO: BaseClient生成時に`fetchApi`オプションで設定すれば、この関数を何十箇所に書かなくても済むのではないか
 */
const handleHTTPError = async (res: Body) => {
  // TODO: OpenAPI Clientがthrowするエラーが全てHTTPError型である保証はない
  const error: HTTPError = await res.json()

  // NOTE: メンテモード、且つ、webの場合にredirectさせるための記述
  if (error.status === 503) {
    const params = error.errors.map(encodeURIComponent).join(',')
    window.location.href = `/maintenance?params=${params}`
  }

  throw error
}

const extractHttpErrorMessages = (error: unknown) => {
  if (isHTTPError(error)) {
    return error.errors.join('\n')
  }
  return undefined
}

export { errorIs, extractHttpErrorMessages, handleHTTPError, isHTTPError }
